import { Snackbar } from '@rbx/ui';
import React, { FC } from 'react';
import { useTranslation } from '@rbx/intl';
import useSnackbarStyles from './Snackbar.styles';

interface ErrorSnackProps {
  open: boolean;
  onClose: () => void;
}

type ErrorSnackbarProps = ErrorSnackProps & {
  message: string;
};

const ErrorSnackbar: FC<React.PropsWithChildren<ErrorSnackbarProps>> = ({
  message,
  open,
  onClose,
}) => {
  const {
    classes: { errorSnack },
  } = useSnackbarStyles();
  return (
    <Snackbar
      ContentProps={{
        classes: {
          root: errorSnack,
        },
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      onClose={onClose}
      message={message}
      autoHideDuration={3000}
    />
  );
};

export default ErrorSnackbar;

// Reusable ErrorSnackbar instances

export const MinNumWordsRequiredErrorSnack = ({
  minNumChars,
  open,
  onClose,
}: { minNumChars: number } & ErrorSnackProps) => {
  const { translate } = useTranslation();
  return (
    <ErrorSnackbar
      open={open}
      onClose={onClose}
      message={translate('Message.MinNumCharactersRequired', {
        minNumChars: String(minNumChars),
      })}
    />
  );
};

export const MaxNumCharsExceededErrorSnack = ({
  maxNumChars,
  open,
  onClose,
}: { maxNumChars: number } & ErrorSnackProps) => {
  const { translate } = useTranslation();
  return (
    <ErrorSnackbar
      open={open}
      onClose={onClose}
      message={translate('Message.MaxNumCharactersExceeded', {
        maxNumChars: String(maxNumChars),
      })}
    />
  );
};

export const FeedbackUnavailableInYourLocaleErrorSnack = ({ open, onClose }: ErrorSnackProps) => {
  const { translate } = useTranslation();
  return (
    <ErrorSnackbar
      open={open}
      onClose={onClose}
      message={translate('Error.FeedbackUnavailableInLocale')}
    />
  );
};
